/*
  개발 예정이기에 모든 코드 임의 변경가능합니다.
*/

import { AuthConnection } from "@/api/config.js";
import { signIn, signOut, getUserInfo, checkTokenAPI } from "@/api/auth.js";
import router from "@/router/index";

export default {
  state: {
    user: null,
    token: null,
    refreshToken: null,
    isLoggedIn: false,
  },
  getters: {
    getToken: (state) => state.token,
    getUserIsLoggedIn: (state) => state.isLoggedIn,
    getRefreshToken: (state) => state.refreshToken,
    getUser: (state) => (state.user ? state.user : {}),
  },
  mutations: {
    CLEAR(state) {
      state.token = null;
      state.user = null;
      state.isLoggedIn = false;
      AuthConnection.defaults.headers["Authorization"] = null;
    },
    SET_TOKEN(state, payload) {
      state.token = `${payload.token_type} ${payload.access_token}`;
      state.refreshToken = payload.refresh_token;
      state.isLoggedIn = true;
      AuthConnection.defaults.headers["Authorization"] = state.token;
    },
    SET_USER(state, payload) {
      state.user = payload;
      if (payload == null) state.isLoggedIn = false;
      else state.isLoggedIn = true;
    },
  },
  actions: {
    signIn({ commit }, payload) {
      return new Promise((resolve, reject) => {
        signIn(payload)
          .then((res) => {
            commit("SET_TOKEN", res.data);
            getUserInfo()
              .then((result) => {
                commit("SET_USER", result.data);
                resolve(result.data);
              })
              .catch((err) => {
                commit("CLEAR");
                reject(err);
              });
          })
          .catch((error) => {
            commit("CLEAR");
            reject(error);
          });
      });
    },
    signOut({ commit, getters }, payload) {
      if (getters.getToken) {
        signOut(getters.getToken);
      }
      commit("CLEAR");
      router.push({ name: "Login", params: payload });
    },
    getUser({ commit }) {
      getUserInfo()
        .then((result) => {
          commit("SET_USER", result.data);
        })
        .catch(() => {
          commit("CLEAR");
        });
    },
    // 모바일 환경 토큰 로그인 체크.
    checkToken({ commit }, payload) {
      return new Promise((resolve, reject) => {
        checkTokenAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            commit("CLEAR");
            reject(err);
          });
      });
    },
  },
};
